<div class="container-fluid">
    <div class="row">
      <div class="col-xl-12">
        <h1 class="page-hd">Rejected Request</h1>
        <div class="content-wrap">
          <div class="table-responsive">
            <table class="ui celled table hover" [dtTrigger]="dtTrigger" datatable [dtOptions]="dtOptions">
              <thead>
                <tr>
                  <th>Company Name</th>
                  <th>Name</th>
                  <!-- <th>Passing Month</th> -->
                  <th>Seat No.</th>
                  <th>Passing Year</th>
                  <th>Stream</th>
                  <th>Branch</th>
                  <th>Semester</th>
                  <th>Document</th>
                  <th>Request Type</th>
                  <th>Preview Document</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of request">
                  <td>{{data.company_name}}</td>
                  <td>{{data.first_name}} {{data.last_name}}</td>
                  <!-- <td>{{data.monthOfPassing}}</td> -->
                  <td> {{data.enroll_no}} </td>
                  <td>{{data.monthOfPassing}}/{{data.year}}</td>
                  <td>{{data.stream_name}}</td>
                  <td>{{data.branch_nm}}</td>
                  <td>{{data.semester}}</td>
                  <td>{{data.doc_name}}</td>
                  <td>{{data.request_type}}</td>
                  <td>
  
                    <!-- <button class='action-btn bg-theme' data-toggle="modal" data-target="#viewModal"
                      (click)="openModal(data.id)">View</button> -->
                    <button class="approve-modal-btn bg-theme mr-auto" (click)="openModal(data.id)">View</button>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- <pdf-viewer [src]="src" [zoom]="1" hidden></pdf-viewer>
            <pdf-viewer [src]="src1" [zoom]="1" hidden></pdf-viewer> -->
            <!-- <img src="../../assets/images/No-results-found.jpg" class="doc-img"> -->
          </div>
        </div>
      </div>
    </div>
  </div>


  <ng-template #showModalBoxTEstingMagnify class="modal fade " id="showModalBoxTEstingMagnify" tabindex="-1" role="dialog" let-c="close"
  let-d="dismiss" aria-labelledby="resetPasswordModalLabel" aria-hidden="false">
  <div class="modal-body">
    <div class="img-magnifier-container">
      <img src="assets/images/certificate.jpg" class="doc-img22"  id="uploadImg1"  width="500" height="500">
    </div>
  </div>
</ng-template>


<ng-template #showModalBoxImage let-modal>
    <div class="modal-content">
      <div class="modal-header bg-theme">
        <h5 class="modal-title" id="viewModalLabel">Preview Document</h5>
        <!-- <button type="button" #closebutton1 class="close" data-dismiss="modal" (click)="modal.dismiss('Cross click')" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button> -->
       
        
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-6">
            <!-- <button   (click)="showmagnify()">Magnify</button>   -->
            <!-- <div *ngIf="!isVrPdf && !noImage1">
              <app-magnify  [imageId]="imgname" [ImageURL]="upload_doc_path"> </app-magnify>
            </div> -->
          
            <p class="doc-txt">To be verified</p>
            <div *ngIf="isVrPdf">
              <div class="ng-star-inserted22">
                <!-- <pdf-viewer [src]="src" [zoom]="1"></pdf-viewer> -->
                <div class="img-magnifier-container">
                  <pdf-viewer [src]="src" [zoom]="1"></pdf-viewer>
                </div>
              </div>
              <button class="new-tab-btn" (click)="openPdf()">Open Doc in Browser</button>
            </div>
            <div *ngIf="isVrImage">
              <!-- <img src={{upload_doc_path}} class="doc-img" (click)="showLightbox(0)" loading="lazy"> -->
              <div class="img-magnifier-container">
                <img src={{upload_doc_path}}  class="doc-img" id="uploadImg1"  (click)="showLightbox(0)" loading="lazy">
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <!-- <button *ngIf="!isUPdf && !noImage2" (click)="showmagnifySystem()">Magnify</button> -->
            <div *ngIf="!isUPdf && !noImage2">
              <app-magnify  [imageId]="imgname2" [ImageURL]="originalDocUploadFilePath"> </app-magnify>
            </div>
            <p class="doc-txt">System document</p>
            <div *ngIf="isUPdf">
              <div class="ng-star-inserted22">
                <!-- <pdf-viewer [src]="src1" [zoom]="1"></pdf-viewer> -->
                <div class="img-magnifier-containeroriginal">
                  <pdf-viewer [src]="src1" [zoom]="1"></pdf-viewer>
                </div>
              </div>
              <button class="new-tab-btn" (click)="openPdf1()">Open Doc in Browser</button>
            </div>
            <div *ngIf="isUImage">
              <!-- <img src={{originalDocUploadFilePath}} class="doc-img" (click)="showLightbox(1)" loading="lazy"> -->
              <div class="img-magnifier-container">
                <img src={{originalDocUploadFilePath}}  class="doc-img"  id="uploadImg2" (click)="showLightbox(1)" loading="lazy">
              </div>
            </div>
          </div>
        </div>
        <button class="approve-modal-btn bg-grey mr-auto" (click)="fetchRejectionTrail()">Rejection Trail</button>
        <!-- <button class="approve-modal-btn bg-theme mr-auto" data-toggle="modal" name="Approved_Pass" data-target="#cgpiModal"
          (click)="openCgpiModal($event)">Match and Pass</button>
        <button class="approve-modal-btn bg-theme mr-auto" data-toggle="modal" name="Approved_Fail" data-target="#cgpiModal"
          (click)="openCgpiModal($event)">Match and Fail</button> -->
        <!-- <button class="reject-modal-btn mr-auto" data-dismiss="modal" name="Rejected" (click)="changeStatus($event)">Negative</button>
        <button class="utv-modal-btn mr-auto" data-dismiss="modal"  name="Unable To Verify" (click)="changeStatus($event)">Unable to verify</button>
        <button class="offline-modal-btn mr-auto" data-dismiss="modal"  name="Offline" (click)="changeStatus($event)">Offline verification</button>     -->
        <!-- <button class="reject-modal-btn mr-auto" data-toggle="modal" data-target="#rejectModal" >Negative</button> -->
        <!-- <button class="reject-modal-btn mr-auto" data-toggle="modal" name="Rejected" data-target="#rejectModal"
          (click)="openRemarkModal($event)">Negative</button>
        <button class="utv-modal-btn mr-auto" data-toggle="modal" name="Unable To Verify" data-target="#onlyRemarkModal"
          (click)="openOnlyRemarkModal($event)">Unable to verify</button>
        <button class="offline-modal-btn mr-auto" data-toggle="modal" name="Offline" data-target="#onlyRemarkModal"
          (click)="openOnlyRemarkModal($event)">Offline verification</button>
        <button class="approve-modal-btn bg-theme mr-auto" data-toggle="modal" name="Ver_Request_Edit" data-target="#editReasonModal"
          (click)="fetchEditReason($event)">Send To edit</button> -->
      </div>
  
    </div>
  
  </ng-template>

  <ng-template #showRejectionTrailBox let-modal>
    <div class="modal-content">
      <div class="modal-header bg-theme">
        <h5 class="modal-title" id="viewModalLabel">Rejection Trail</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="table-fixed-ht">
        <div class="table-responsive">
          <table class="ui celled table hover cust-table">
            <thead>
              <th>Role</th>
              <th>Date</th>
              <th>Reject Reason</th>
            </thead>
            <tbody>
              <tr *ngIf="!rejectionTrail">
                <td>No data found</td>
              </tr>
              <tr *ngFor="let data of rejectionTrail">
                <td>{{data.role}}</td>
                <td>{{data.date}}</td>
                <td>{{data.reason}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </ng-template>